export const UI_CONSTANTS = {
    SIDEBAR_WIDTH_COLLAPSED: 70,
    SIDEBAR_WIDTH_EXPANDED: 256,
    HEADER_HEIGHT: 97,
    ANIMATION_DURATION: 300,
    DEBOUNCE_DELAY: 300,
} as const

export const BREAKPOINTS = {
    SM: 640,
    MD: 768,
    LG: 1024,
    XL: 1280,
    '2XL': 1536,
} as const
